import '@pressreader/src/externalsystems/providers.init';
import '@pressreader/src/externalsystems/signin.init';

import { registerFeature } from './store';

let initialized = false;

function init() {
    if (initialized) {
        return;
    }

    initialized = true;

    registerFeature();
}

export { init };
